<template>
<div id="PlayerControls">
  <div class="controls-wrap">
    <div class="play-and-info" @click="operationEntry('toggle-play')">
      <div class="toggle-play">
        <vui-ico class="ibang-pause" v-if="playing"></vui-ico>
        <vui-ico class="ibang-play" v-else></vui-ico>
      </div>

      <div class="info">
        <span class="live-duration">已直播 {{ duration }}</span>
        <div class="vertical-split"></div>
        <span class="audience-amount"> {{ audienceAmount }}在线</span>
      </div>
    </div>
    <div class="toggle-full-screen" @click="operationEntry('toggleFullScreen')">
      <vui-ico class="ibang-full-screen" v-if="!fullScreen"></vui-ico>
      <vui-ico class="ibang-min-screen" v-else></vui-ico>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    player: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      playing: false,
      fullScreen: false,
      duration: '30:19',
      audienceAmount: 1315,
    }
  },
  methods: {
    playerEventListen () {

    },
    operationEntry (type) {
      if (!this.player) {
        return false
      }
      this[type]()
    },
    togglePlay () {
      this.playing
        ? this.player.pause()
        : this.player.play()
    },
    toggleFullScreen () {
      this.fullScreen
        ? this.player.exitFullscreen()
        : this.player.enterFullscreen()
    },
  },
}
</script>

<style lang="scss">
:-webkit-full-screen {
  z-index: 20;
}
:-webkit-full-screen-ancestor>:not(:-webkit-full-screen-ancestor):not(:-webkit-full-screen) {
  display: block !important
}

:-moz-full-screen-ancestor>:not(:-moz-full-screen-ancestor):not(:-moz-full-screen) {
  display: block !important
}

:-ms-fullscreen-ancestor>:not(:-ms-fullscreen-ancestor):not(:-ms-fullscreen) {
  display: block !important
}

:fullscreen-ancestor>:not(:fullscreen-ancestor):not(:fullscreen) {
  display: block !important
}

#PlayerControls {
  position: relative;
  height: 44px;
  width: 100%;
  .vui-ico {
    cursor: pointer;
  }
  .controls-wrap {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 2147483647;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: white;
    text-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
    line-height: 44px;
  }
  .play-and-info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    &>* {
      margin-left: 10px;
    }
  }
  .toggle-play {
    height: 24px;
  }
  .info {
    height: 18px;
    line-height: 18px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &>* {
      margin-left: 10px;
    }
    .vertical-split {
      height: 12px;
      width: 1px;
      background: #ffffff;
    }
  }
  .toggle-full-screen {
    height: 24px;
    margin-right: 10px;
  }
}
</style>
